export default "__VITE_ASSET__CO46ztv3__"